export default {
	reviewsOffset: ['$stateParams', '$state', function ($stateParams,$state) {
		return  $stateParams.reviewsOffset || 0;
	}],
	commentsFilter: ['$stateParams', '$state', function ($stateParams,$state) {
		return  $stateParams.commentsFilter || 'all';
	}],
	ratingFilter: ['$stateParams', '$state', function ($stateParams,$state) {
		return  $stateParams.ratingFilter || 'all';
	}],
	npsFilter: ['$stateParams', '$state', function ($stateParams,$state) {
		return  $stateParams.npsFilter || 'all';
	}],
};



// WEBPACK FOOTER //
// ./src/page/reviews/reviews.resolve.js